import { Icon } from '@toasttab/shared/src/utils/craftUtils'
import classNames from 'classnames'

const buildVideo = (cta: any, variation: string) => {
  const classes = classNames('!flex mb-8', {
    '!justify-start': variation === 'Default'
  })
  return {
    classes,
    labelOutside: true,
    playButtonClasses: '!static !px-4 !py-2 !h-auto',
    sectionHeading: cta.video.label,
    fontWeight: ['font-semibold'],
    typeHandle: 'video',
    vidyardId: cta.video.vidyardId,
    numComponents: 1
  }
}
export const buildButton = (button: any) => {
  return {
    buttonSize: 'Medium',
    buttonVariations: 'primary',
    fontWeight: ['font-semibold'],
    classes: 'mb-6',
    ctaLabel: button.label,
    ctaLink: button.url,
    numComponents: 1,
    typeHandle: 'button'
  }
}
const buildTwoButtons = (buttons: any) => {
  return {
    typeHandle: 'twoButtons',
    classes: 'mb-6',
    children: buttons.map((button: any, i: number) => {
      return {
        ctaLabel: button.label,
        ctaLink: button.url,
        buttonPadding: 'Medium',
        buttonVariations: i === 0 ? 'Primary' : 'Secondary'
      }
    })
  }
}
export const buildTextLink = (cta: any, inlineHeading: boolean = false, classes: string = '') => {
  return {
    wrapperClasses: classes,
    ctaLabel: cta.label,
    ctaLink: cta.url,
    inlineHeading,
    linkIcons: Icon.linkIcons(cta.icon),
    sectionHeading: cta.caption,
    numComponents: 1,
    typeHandle: 'textLink'
  }
}

export const heroCtas = (ctas: any, inlineTextHeading: boolean = false, variation: string = '') => {
  const buttons = ctas ? ctas.filter((cta: any) => cta.__typename === 'ContentfulMdsButton') : []
  const links = ctas ? ctas.filter((cta: any) => cta.__typename === 'ContentfulMdsLink') : []
  const standardButtons = buttons.filter((button: any) => !button.video)
  const videoButtons = buttons.filter((button: any) => button.video !== null && button.video.vidyardId)

  const countButton = standardButtons.length
  const countLink = links.length
  const countVideo = videoButtons.length

  let ctaComponents = []

  if (countButton === 1) {
    const button = buildButton(standardButtons[0])
    if (countLink > 1) {
      button.classes = ''
    }
    if (countButton === 1 && countLink === 1) {
      button.classes += ' mr-4 '
    }
    ctaComponents.push(button)
  }
  if (countButton === 2) {
    ctaComponents.push(buildTwoButtons(standardButtons))
  }
  if (countVideo > 0) {
    ctaComponents.push(buildVideo(videoButtons[0], variation))
  }
  if (countLink > 0) {
    const linkComponents = links.map((link: any, i: number) => {
      const classes = i + 1 === countLink ? 'mb-10' : ''
      inlineTextHeading = countLink > 1
      return buildTextLink(link, inlineTextHeading, classes)
    })
    ctaComponents = [...ctaComponents, ...linkComponents]
  }

  return ctaComponents
}
